import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "../Button";
import Menu from "../Menu/Menu";
import PropTypes from "prop-types";
import classNames from "classnames";
import { styles } from "./styles";
import { withStyles } from "@material-ui/core/styles";
export class ButtonDropDown extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        options,
        id,
        className,
        classes,
        fullWidth,
        color
      } = this.props;
      const renderedOptions = [...options];
      const defaultOption = renderedOptions.shift();
      const calculatedColor = defaultOption ? defaultOption.color || color : color;
      const disabled = defaultOption && "disabled" in defaultOption && defaultOption.disabled;
      const primaryClassName = defaultOption && "className" in defaultOption ? defaultOption.className : undefined;
      return defaultOption ? /*#__PURE__*/React.createElement("div", {
        className: classNames("prmbl-buttonDropDown", classes.root, className, {
          [classes.fullWidth]: fullWidth
        }),
        id: id
      }, /*#__PURE__*/React.createElement(Button, _extends({
        color: calculatedColor
      }, defaultOption, {
        fullWidth: fullWidth,
        className: classNames("prmbl-buttonDropDown-primary", {
          [primaryClassName]: primaryClassName
        })
      })), renderedOptions.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: classNames(classes.menuButtonRoot, disabled ? classes.disabled : classes[calculatedColor])
      }, /*#__PURE__*/React.createElement(Menu, {
        id: `${id}-dropDownMenu`,
        className: classNames("prmbl-buttonDropDown-menu"),
        classes: {
          item: classes.itemWrap,
          paper: classes.buttonMenu,
          button: classes.menuButton
        },
        icon: /*#__PURE__*/React.createElement(ArrowDropDown, null),
        type: "topbar",
        items: renderedOptions.map((option, index) => ({
          children: /*#__PURE__*/React.createElement(Button, _extends({
            color: color,
            className: classes.menuItem,
            fullWidth: true
          }, option)),
          onClick: () => {
            // do nothing
          }
        }))
      }))) : null;
    });
  }
}
_defineProperty(ButtonDropDown, "propTypes", {
  /**
   * The html id
   */
  id: PropTypes.string,
  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: PropTypes.object.isRequired,
  /**
   * If `true`, the ButtonDropDown will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * The color of the component. It supports those those theme colors
   * that make sense for this component
   */
  color: PropTypes.oneOf(["default", "primary", "secondary", "inherit"]),
  /**
   * An array of `Button` props
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    /**
     * The html id
     */
    id: PropTypes.string,
    /**
     * The content of the button.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override the component rendered
     */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * If `true`, the button will be disabled.
     */
    disabled: PropTypes.bool,
    /**
     * The URL to link to when the button is clicked. If desired, an `a` element will
     * be used as the root node.
     */
    href: PropTypes.string,
    /**
     * Callback to execute when the button is pressed
     */
    onClick: PropTypes.any,
    /**
     * The size of the button. `small` is equivalent to the dense button styling.
     */
    size: PropTypes.oneOf(["small", "medium", "large"]),
    /**
     * The type of button to render
     */
    type: PropTypes.oneOf(["default", "icon"]),
    /**
     * The style of button.
     */
    variant: PropTypes.oneOf(["contained", "outlined", "text"]),
    /**
     * Set true to open the href in a new window.
     */
    openInNewWindow: PropTypes.bool,
    /**
     * The color type.
     */
    color: PropTypes.oneOf(["default", "primary", "secondary"])
  })).isRequired,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string
});
export default withStyles(styles)(ButtonDropDown);